import { OrderPaymentChannel, OrdersDeliveryType, OrdersStatus, OrdersPaymentStatus } from '@/models/orders.model';
import { COLORS } from '@/theme';

export const getPaymentChannelData = (channel?: OrderPaymentChannel | null) => {
  if (!channel) {
    return null;
  }

  return `orders_payment_channel_${channel}`;
};

export const getDeliveryTypeData = (type?: OrdersDeliveryType) => {
  switch (type) {
    case OrdersDeliveryType.GOST:
      return 'orders_delivery_type_gost';
    case OrdersDeliveryType.NOVA_POSHTA:
      return 'orders_delivery_type_nova_poshta';
    default:
      return 'orders_delivery_type_pickup';
  }
};

export const getStatusData = (status: OrdersStatus, type?: OrdersDeliveryType) => {
  switch (status) {
    case OrdersStatus.NEW:
      return { text: 'orders_status_new', color: COLORS.DEEP_TEAL };
    case OrdersStatus.PROCESSING:
      return { text: 'orders_status_processing', color: COLORS.ORANGE };
    case OrdersStatus.COMPLETED:
      return { text: 'orders_status_completed', color: COLORS.GREEN };
    case OrdersStatus.ACCEPTED:
      return { text: 'orders_payment_status_approved', color: COLORS.GREEN };
    case OrdersStatus.READY_FOR_TTN:
      return { text: 'orders_status_ready_for_ttn', color: COLORS.YELLOW_PRIMARY };
    case OrdersStatus.TRANSFERRED:
      if (type === OrdersDeliveryType.GOST) {
        return { text: 'orders_status_transferred_delivery_gost', color: COLORS.BLUE };
      }
      if (type === OrdersDeliveryType.NOVA_POSHTA) {
        return { text: 'orders_status_transferred_pickup_nova_poshta', color: COLORS.PINK };
      }
      return { text: 'orders_status_transferred_pickup_gost', color: COLORS.PURPLE };
    case OrdersStatus.AWAITING:
      if (type === OrdersDeliveryType.PICKUP) {
        return { text: 'orders_status_awaiting_pickup_gost', color: COLORS.YELLOW_PRIMARY };
      }
      return { text: 'orders_status_awaiting_pickup_nova_poshta', color: COLORS.DARK_RED };
    case OrdersStatus.RESERVE:
      return { text: 'orders_status_reserve', color: COLORS.PURPLE };
    default:
      return { text: 'orders_status_cancelled', color: COLORS.RED };
  }
};

export const getPaymentStatusData = (paymentStatus: OrdersPaymentStatus) => {
  switch (paymentStatus) {
    case OrdersPaymentStatus.AWAITING_PAYMENT:
      return { text: 'orders_payment_status_awaiting_payment', color: COLORS.MID_STEEL_GRAY };
    case OrdersPaymentStatus.AWAITING_PREPAYMENT:
      return { text: 'orders_payment_status_awaiting_prepayment', color: COLORS.ORANGE };
    case OrdersPaymentStatus.PREPAID:
      return { text: 'orders_payment_status_prepaid', color: COLORS.PURPLE };
    case OrdersPaymentStatus.CASH_ON_DELIVERY:
      return { text: 'orders_payment_status_cash_on_delivery', color: COLORS.BLUE };
    case OrdersPaymentStatus.CANCELLED:
      return { text: 'orders_payment_status_cancelled', color: COLORS.RED };
    case OrdersPaymentStatus.PAYMENT_REFUND:
      return { text: 'orders_payment_status_payment_refund', color: COLORS.RED };
    case OrdersPaymentStatus.PREPAYMENT_REFUND:
      return { text: 'orders_payment_status_prepayment_refund', color: COLORS.DARK_RED };
    case OrdersPaymentStatus.AWAITING_ADDITIONAL_PAYMENT:
      return { text: 'orders_payment_status_awaiting_additional_payment', color: COLORS.ORANGE };
    case OrdersPaymentStatus.REQUIRES_PARTIAL_REFUND:
      return { text: 'orders_payment_status_requires_partial_refund', color: COLORS.PINK };
    case OrdersPaymentStatus.PAID:
      return { text: 'orders_payment_status_paid', color: COLORS.GREEN };
    default: {
      const exhaustiveStatus: never = paymentStatus;
      void exhaustiveStatus;
      return { text: 'orders_payment_status_paid', color: COLORS.GREEN };
    }
  }
};
